import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { DocumentoService } from '../../../services/documento.service';
import { NumeracionDocumento } from '../../../models/Document';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { AuthService } from '../../../services/auth.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: 'app-dlg-numeracion',
    imports: [
    MatDialogModule, MatButtonModule,
    MatListModule, MatProgressBarModule,
    MatTableModule, MatCheckboxModule,
    MatRadioModule, FormsModule,
],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './dlg-numeracion.component.html',
    styleUrl: './dlg-numeracion.component.scss'
})
export class DlgNumeracionComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<DlgNumeracionComponent>)
  readonly data = inject<string>(MAT_DIALOG_DATA);

  loading=true;
  tokenData= this.authService.getTokenData();

  numeracionesDocumento: NumeracionDocumento[] = []
  numeracionSeleccionada: NumeracionDocumento | undefined

  constructor(
    private documentoService: DocumentoService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadNumeracionDocumento()
  }

  loadNumeracionDocumento() {
    this.loading=true;
    this.documentoService.getNumeraciones(this.tokenData?.id).subscribe({
      next: (response) => {
        this.numeracionesDocumento = response
        this.loading=false;
        this.cdr.detectChanges()
      }
    })
  }

  onEditConfirm() {
    this.dialogRef.close(1)
  }

  onDlgAccepted() {
    this.dialogRef.close(this.numeracionSeleccionada)
  }
}
